import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { jobs as jobsApi, stats as statsApi } from '../services/api';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();
  const [recentJobs, setRecentJobs] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const jobsResponse = await jobsApi.getAll();
      setRecentJobs(jobsResponse.data.slice(0, 5));

      if (user.is_admin) {
        const statsResponse = await statsApi.get();
        setStats(statsResponse.data);
      }
    } catch (error) {
      console.error('Failed to load dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div className="page">
      <div className="page-header">
        <h1>Welcome back, {user.username}!</h1>
        <p>Manage your automated code changes from the cloud</p>
      </div>

      {user.is_admin && stats && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-value">{stats.total_jobs}</div>
            <div className="stat-label">Total Jobs</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.completed_jobs}</div>
            <div className="stat-label">Completed</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.running_jobs}</div>
            <div className="stat-label">Running</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.total_users}</div>
            <div className="stat-label">Users</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.total_repos}</div>
            <div className="stat-label">Repositories</div>
          </div>
        </div>
      )}

      <div className="card">
        <h2 style={{ marginBottom: '20px' }}>Quick Actions</h2>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <Link to="/jobs">
            <button className="btn-secondary">📋 View All Jobs</button>
          </Link>
          {user.is_admin && (
            <Link to="/admin">
              <button className="btn-secondary">⚙️ Admin Panel</button>
            </Link>
          )}
        </div>
      </div>

      <div className="card">
        <h2 style={{ marginBottom: '20px' }}>Recent Jobs</h2>
        {recentJobs.length === 0 ? (
          <p style={{ color: '#64748b' }}>No jobs yet. Create your first job to get started!</p>
        ) : (
          recentJobs.map((job) => (
            <div key={job.id} className="job-card">
              <div className="job-header">
                <div>
                  <h3>{job.repository.name}</h3>
                  <p style={{ color: '#64748b', fontSize: '14px' }}>{job.command}</p>
                </div>
                <span className={`job-status status-${job.status}`}>{job.status}</span>
              </div>
              {job.pr_url && (
                <a href={job.pr_url} target="_blank" rel="noopener noreferrer" style={{ color: '#64748b' }}>
                  View Pull Request →
                </a>
              )}
              {job.error_message && (
                <div className="alert alert-error" style={{ marginTop: '12px' }}>
                  {job.error_message}
                </div>
              )}
            </div>
          ))
        )}
        {recentJobs.length > 0 && (
          <Link to="/jobs" style={{ display: 'inline-block', marginTop: '16px', color: '#64748b', fontWeight: '600' }}>
            View all jobs →
          </Link>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
